/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/28/21
 */

import React from "react";
import {Box, useTheme} from "@mui/material";
import {borderedSx, cellSx, lastOfTypeX, todaySx, weekendSx} from "./sx";
import {isWeekend, isToday, addMinutes} from "date-fns"
import {Employee, VegaEvent} from "../interfaces/Global";
import zonedTimeToUtc from "date-fns-tz/zonedTimeToUtc";

export interface EmptyCellProps {
	rangeResolution: number
	interval: Date
	intervalDuration: number
	employee: Employee
	openNewEventDialog: (event: Partial<VegaEvent>) => void
	width: number
}

const emptySx = {
	transition: "all 0.10s ease-in-out",
	outline: "none",
	cursor: "pointer",

	"&:hover": {
		boxShadow: "0px 0px 10px 3px #51cbee",
		zIndex: 1
	}
};

export default function EmptyCell(props: EmptyCellProps) {

	const theme = useTheme();
	const weekend = isWeekend(props.interval), today = isToday(props.interval);

	const startDate = zonedTimeToUtc(props.interval, props.employee.timeZone);

	return (
		<Box
			onClick={ () => props.openNewEventDialog({
				startDatetime: startDate,
				endDatetime: addMinutes(startDate, props.intervalDuration)
			}) }
			sx={{
				...cellSx,
				minWidth: props.width,
				maxWidth: props.width,
				...borderedSx(theme),
				...lastOfTypeX(theme),
				...emptySx,
				...(props.rangeResolution < 1 && weekend ? weekendSx(theme) : {}),
				...(props.rangeResolution < 1 && today ? todaySx(theme) : {}),
			}}
		/>
	);

}